module.exports = __webpack_public_path__ + "img/add_to_cart.dff06856.svg";